import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-progress-card',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './progress-card.component.html',
  styleUrl: './progress-card.component.scss',
})
export class ProgressCardComponent {
  completionRate = input<number>(0);

  badgeTextKey = computed(() => {
    const rate = this.completionRate();
    if (rate === 0) {
      return 'app.components.progressCard.badgeText.start';
    } else if (rate < 25) {
      return 'app.components.progressCard.badgeText.beginner';
    } else if (rate < 50) {
      return 'app.components.progressCard.badgeText.good';
    } else if (rate < 75) {
      return 'app.components.progressCard.badgeText.great';
    } else if (rate < 100) {
      return 'app.components.progressCard.badgeText.excellent';
    } else {
      return 'app.components.progressCard.badgeText.completed';
    }
  });
}
